import { ORDER_ITEM_PRODUCT_TYPE } from '@/utils/enum.js';
import SaveDataUtil from '@/utils/saveDataToLocal';
import { JOB_TITLE_NAME } from '@/utils/enum-name';

const commonMixin = {
  data() {
    return {
      employee: {
        name: '',
        store: {
          id: '',
          name: '',
          address: '',
          area: {
            id: '',
            name: '',
          },
        },
      },
      jobTitleId: '',
      storeList: [],
    };
  },
  created: function () {},
  methods: {
    handleOrderItemUpsert(orderItems) {
      const itemHandlers = orderItems.map((item) => {
        item.productName = item.productName || item.product?.name;

        switch (item.orderItemProductType) {
          case ORDER_ITEM_PRODUCT_TYPE.MAIN: {
            item.productType = ORDER_ITEM_PRODUCT_TYPE.MAIN;
            break;
          }
          case ORDER_ITEM_PRODUCT_TYPE.GIFT: {
            item.productType = ORDER_ITEM_PRODUCT_TYPE.GIFT;
            break;
          }
          case ORDER_ITEM_PRODUCT_TYPE.ATTACH: {
            item.productType = ORDER_ITEM_PRODUCT_TYPE.ATTACH;
            break;
          }
        }
        item.productPrice = Number(item.sellingPriceMask);
        return item;
      });

      const mainItems = itemHandlers.filter(
        (item) => item.orderItemProductType === ORDER_ITEM_PRODUCT_TYPE.MAIN,
      );
      const relatedItems = itemHandlers.filter(
        (item) => item.orderItemProductType !== ORDER_ITEM_PRODUCT_TYPE.MAIN,
      );

      return mainItems.map((mainItem) => {
        const gifts = relatedItems.filter(
          (item) =>
            item.belongOrderDetailId === mainItem.id &&
            item.orderItemProductType === ORDER_ITEM_PRODUCT_TYPE.GIFT,
        );

        const attachs = relatedItems.filter(
          (item) =>
            item.belongOrderDetailId === mainItem.id &&
            item.orderItemProductType === ORDER_ITEM_PRODUCT_TYPE.ATTACH,
        );
        mainItem.gifts = gifts;
        mainItem.attachs = attachs;
        return mainItem;
      });
    },
    getEmployeeFromLocal() {
      const userFromLocal = SaveDataUtil.getData('employee_info');
      if (userFromLocal) {
        return JSON.parse(userFromLocal);
      }
    },
    getJobTitleFromLocal(jobTitleId) {
      if (!jobTitleId) {
        return;
      }
      const data = !isNaN(Number(jobTitleId)) ? Number(jobTitleId) : 0;
      if (JOB_TITLE_NAME[data]) {
        return JOB_TITLE_NAME[data];
      }
      return 'NON_IDENTIFIED JOB TITLE';
    },
  },
};
export default commonMixin;
